import styled from "styled-components";
import Input from "../Input";
import { useState } from "react";
//import DatePicker from "react-date-picker";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
//import "react-date-picker/dist/DatePicker.css";
import DatePickerIcon from "../../../../src/assets/datepicker.png"

const StyledFormDatePicker = styled.div`
    display: block;
    padding-top: 15px;
    align-items: center;

    input {
        margin-top: 5px;
        padding: 9px 13px;
        height: 35px;
        font-size: 12px;
        font-weight: 400;
        box-sizing: border-box;
        width: 100%;
        background-image: url(${DatePickerIcon});
        background-repeat: no-repeat;
        background-size: 17px 18px;
        background-position: right 10px center;
        border: solid 1px ${(props) => props.theme.color.bordergray};
        border-radius: 2px;
        color: ${(props) => props.theme.color.dark};
        font-family: ${(props) => props.theme.fonts.SegoeUI};

        :focus {
            outline: none !important;
            border:1px solid ${(props) => props.validated === undefined ? props.theme.color.primaryblue : ''};
        }
    
        :disabled {
            outline: none !important;
            border: solid 1px ${(props) => props.theme.color.bordergray};
            color: ${(props) => props.theme.color.gray};
            background-color: ${(props) => props.theme.color.disabledgray}
        }
    
        ${({ validated }) => validated === false && `
            border: solid 1px #dc3545;
            color: #dc3545;
        `}
    
        ${({ validated }) => validated === true && `
            border: solid 1px #198754;
            color: #198754;
        `}
    }

    .react-date-picker {
        width: 100%;
        height: 35px;
        margin-top: 5px;
    }

    .react-date-picker--open {
        .react-date-picker__wrapper {
            outline: none !important;
            border:1px solid ${(props) => props.validated === undefined ? props.theme.color.primaryblue : ''};
        }
    }

    .react-date-picker__wrapper {
        font-family: ${(props) => props.theme.fonts.SegoeUI};
        ${({ validated }) => validated === false && `
            border: #dc3545;
            color: #dc3545;
        `}
    
        ${({ validated }) => validated === true && `
            border: #198754;
            color: #198754;
        `}
    }

    .react-date-picker__inputGroup {
        padding-left: 13px;
    }

    .react-date-picker__inputGroup__input {
        padding: 0;
        margin-top: 0;
    }
`;

const LabelRegular = styled.div`
    font-size: 12px;
    font-weight: 600;
`;

function FormDatePicker(props) {

    const {label, value, onChange, disabled, validated, ...restProps} = props;

    const onChangeDate = (val) => {
        // let diffMinutes = val.getTimezoneOffset();
        // val.setTime(val.getTime() - diffMinutes*60*1000);
        if (onChange) onChange(val);
    }

    return (
        <StyledFormDatePicker {...restProps} validated={validated}>
            {label && <LabelRegular>{label}</LabelRegular>}
            {/* <DatePicker value={value} startDate={value} activeStartDate={value} format='dd/MM/yyyy' onChange={(val) => onChangeDate(val)} disabled={disabled} clearIcon={null}></DatePicker> */}
            <DatePicker selected={value} dateFormat='dd/MM/yyyy' onChange={(val) => onChangeDate(val)} disabled={disabled} validated={validated}></DatePicker>
        </StyledFormDatePicker>
    )
}

export default FormDatePicker;